import { MEMBER_EXPECTATIONS_CONTENT } from '../constants/memberExpectationsContent'

const MemberExpectationsWelcomePack = () => {
  const c = MEMBER_EXPECTATIONS_CONTENT

  return (
    <div className="text-black">
      <header className="mb-10 sm:mb-12">
        <p className="font-AXONALLPrimeMedium text-[11px] sm:text-xs uppercase tracking-[0.28em] text-neutral-500 mb-4">
          {c.brand}
        </p>
        <h2 className="font-AXONALLPrimeSemiBold text-3xl sm:text-4xl text-black tracking-tight leading-tight">
          {c.pageTitle}
        </h2>
      </header>

      <div className="border border-black bg-neutral-100/90 px-5 py-5 sm:px-7 sm:py-6 mb-12 sm:mb-16">
        <p className="font-AXONALLPrimeSemiBold text-[15px] sm:text-base leading-relaxed text-black text-center">
          {c.callout}
        </p>
      </div>

      <ol className="list-none m-0 p-0 space-y-12 sm:space-y-14">
        {c.items.map((item) => (
          <li key={item.n}>
            <h3 className="font-AXONALLPrimeSemiBold text-lg sm:text-xl text-black tracking-tight mb-3 tabular-nums">
              {item.n}. {item.title}
            </h3>
            <p className="font-poppinsLight text-[15px] sm:text-base leading-[1.75] text-neutral-800 m-0 max-w-none">
              {item.body}
            </p>
          </li>
        ))}
      </ol>
    </div>
  )
}

export default MemberExpectationsWelcomePack
